import { Reducer } from "redux";

import { UrgencyStatusActionDispatchTypes } from "../constants/Patient";
import { UrgencyStatusMasterResponse } from "../models/Api/Patient";
import { UrgencyStatusDispatchTypes } from "../models/DispatchTypes/Patient";
import { setLocalStorageData } from "../utils";

export const initialState: UrgencyStatusMasterResponse = {
  loading: false,
  response: [],
};

const UrgencyStatusReducer: Reducer<
  UrgencyStatusMasterResponse,
  UrgencyStatusDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case UrgencyStatusActionDispatchTypes.GET_URGENCY_STATUS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case UrgencyStatusActionDispatchTypes.GET_URGENCY_STATUS_SUCCESS: {
      setLocalStorageData(
        UrgencyStatusActionDispatchTypes.GET_URGENCY_STATUS_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case UrgencyStatusActionDispatchTypes.GET_URGENCY_STATUS_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default UrgencyStatusReducer;
